document.addEventListener("DOMContentLoaded", function() {

    window.addEventListener("click", function(event) {
        const target = event.target;
        console.log("event", target.classList.contains("ss-variant-option-plus-icon"));

        if(target.classList.contains("ss-variant-option-plus-icon")) {
            target.closest(".ss-variant-option-group").classList.add("show-all");
            target.classList.add("is-hidden");
        }
    });

});